import { useQuery } from "react-query";
import { useXeroClient } from "../hooks";

export const useTaxRates = (config) => {
  const xero = useXeroClient();

  return useQuery({
    queryKey: "taxrates",
    queryFn: () =>
      xero
        .get("taxrates")
        .get("data")
        .map((i) => ({
          ...i,
          Name: `${i.Name} (${i.DisplayTaxRate}%)`,
        })),
    ...(config ?? {}),
  });
};
